import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpProvider } from "../http/http";

/*
  Generated class for the SignProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SignProvider {

  constructor(public http: HttpProvider) {
    console.log("Hello SignProvider Provider");
  }

  getSignList(page, pagesize, date_type, order,timestamp) {
    let params = {
      page: page,
      pagesize: pagesize,
      date_type: date_type,
      order: order,
      timestamp:timestamp
    };
    return this.http.hPost("/sign/get_list", params);
  }

  getRule() {
    return this.http.hPost("/sign/get_rule");
  }

  modifyRule(params) {
    let p = JSON.parse(JSON.stringify(params));
    p.sign_coin = p.sign_coin.map(item => parseInt(item.coin));
    p.sign_time_type = parseInt(p.sign_time_type);
    p.sign_type = parseInt(p.sign_type);
    p.sign_word_type = parseInt(p.sign_word_type);
    p.sign_time_end = Math.ceil(p.sign_time_end / 1000);
    p.sign_time_start = Math.ceil(p.sign_time_start / 1000);
    p.sign_tip_time = Math.ceil(p.sign_tip_time / 1000);

    return this.http.hPost("/sign/modify_rule", p);
  }

  getMemberList(page, pagesize, date_type, chatroomname,timestamp) {
    let params = {
      page: page,
      pagesize: pagesize,
      date_type: date_type,
      chatroomname: chatroomname,
      timestamp: timestamp
    };
    return this.http.hPost("/sign/member_list", params);
  }

  getMemberInfo(username, chatroomname,timestamp) {
    let params = {
      username: username,
      chatroomname: chatroomname,
      timestamp:timestamp
    };
    return this.http.hPost("/sign/member_info", params);
  }

  getMemberMonthInfo(username, chatroomname, start, end) {
    let params = {
      username: username,
      chatroomname: chatroomname,
      start_time: start / 1000,
      end_time: end / 1000
    };
    return this.http.hPost("/sign/member_month_info", params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/sign/sign.ts